<template>
  <CRow>
    <CCol col="12" xl="6">
      <CCard>
        <CCardHeader>
          <strong>Γενικά στοιχεία</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
            <CInput horizontal type="text" label="ΑΦΜ" addLabelClasses="requiredLabel" id="afm" placeholder="ΑΦΜ" v-model="afm" @change="checkAfm()"></CInput>
            <CInput horizontal type="text" label="Επωνυμία Οργανισμού (Ελληνικά)" addLabelClasses="requiredLabel" required id="company" placeholder="Επωνυμία Οργανισμού" v-model="company"></CInput>
            <CInput horizontal type="text" label="Επωνυμία Οργανισμού (Αγγλικά) - για πιστοποιητικό" id="company_en" placeholder="Επωνυμία Οργανισμού" v-model="company_en"></CInput>
            <CInput horizontal type="text" label="E-mail Επικοινωνίας (1)" id="email_1" placeholder="Email 1" v-model="email_1"></CInput>
            <CInput horizontal type="text" label="E-mail Επικοινωνίας (2)" id="email_2" placeholder="Email 2" v-model="email_2"></CInput>
            <CInput horizontal type="text" label="Διεύθυνση Οργανισμού" required addLabelClasses="requiredLabel" id="address" placeholder="Διεύθυνση Οργανισμού" v-model="address"></CInput>
            <CInput horizontal type="text" label="Υπεύθυνος Επικοινωνίας" id="contact_name" placeholder="Υπεύθυνος Επικοινωνίας" v-model="contact_name"></CInput>
            <CInput horizontal type="text" label="Τηλ. Επικοινωνίας (1)" id="phone_1" placeholder="Τηλέφωνο" v-model="phone_number_1"></CInput>
            <CInput horizontal type="text" label="Τηλ. Επικοινωνίας (2)" id="phone_2" placeholder="Τηλέφωνο" v-model="phone_number_2"></CInput>
            <CInput horizontal type="text" label="Fax" id="fax" placeholder="Fax" v-model="fax"></CInput>
            <CInput horizontal type="text" label="Ιστοσελίδα" id="website" placeholder="Ιστοσελίδα" v-model="website"></CInput>
            <CInput horizontal type="text" label="Πόλη" addLabelClasses="requiredLabel" id="town" placeholder="Πόλη" v-model="town"></CInput>
            <CInput horizontal type="text" label="Νομός" addLabelClasses="requiredLabel" id="state" placeholder="Νομός" v-model="state"></CInput>
            <CInput horizontal type="text" label="Ταχυδρομικός Κώδικας" id="postcode" placeholder="Ταχυδρομικός Κώδικας" v-model="postcode"></CInput>
            <div class="form-row form-group">
              <CCol sm="3" class="pt-1">
                Χώρα
              </CCol>
              <CCol sm="9">
                <multiselect 
                  v-model="countries" 
                  id="countries" 
                  :options="countriesOptions"
                  label="label"
                  track-by="label">
                </multiselect>
              </CCol>
            </div>
            <div class="form-row form-group">
              <CCol tag="label" sm="3" class="col-form-label">
                Ενεργός
              </CCol>
              <CCol sm="9" class="col-form-label">
                <CSwitch :checked.sync="active" shape="pill" color="success"/>
              </CCol>
            </div>
            <div class="form-row form-group">
              <CCol tag="label" sm="3" class="col-form-label">
                Έχει σταλεί προσφορά στον πελάτη
              </CCol>
              <CCol sm="9" class="col-form-label">
                <CSwitch :checked.sync="deal_sent" shape="pill" color="success"/>
              </CCol>
            </div>
            <div class="form-row form-group">
              <CCol tag="label" sm="3" class="col-form-label">
                Έχει υπογράψει σύμβαση
              </CCol>
              <CCol sm="9" class="col-form-label">
                <CSwitch :checked.sync="signed_deal" shape="pill" color="success"/>
              </CCol>
            </div>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="12" xl="6">
      <CCard>
        <CCardHeader>
          <strong>Οικονομικά στοιχεία</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CInput horizontal type="text" label="ΔΟΥ" addLabelClasses="requiredLabel" id="doy" placeholder="ΔΟΥ" v-model="doy"></CInput>
            <CTextarea
                label="Άλλες Πληροφορίες / Σχόλια"
                placeholder="Άλλες Πληροφορίες / Σχόλια"
                horizontal
                rows="9"
                v-model="notes"
            />
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          <strong>Στοιχεία B2G (Κυβερνητικός Φορέας)</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <div class="form-row form-group">
              <CCol tag="label" sm="3" class="col-form-label">
                Είναι Κυβερνητικός Φορέας
              </CCol>
              <CCol sm="9" class="col-form-label">
                <CSwitch :checked.sync="is_government" shape="pill" color="info"/>
              </CCol>
            </div>

            <div v-if="is_government">
              <div class="form-row form-group">
                <CCol sm="3" class="pt-1">
                  Τύπος Φορέα
                </CCol>
                <CCol sm="9">
                  <multiselect
                    v-model="government_type"
                    :options="governmentTypeOptions"
                    label="label"
                    track-by="value"
                    placeholder="Επιλέξτε τύπο φορέα">
                  </multiselect>
                </CCol>
              </div>

              <CInput horizontal type="text" label="Κωδικός Δήμου Καλλικράτη" id="municipality_code" placeholder="π.χ. 0601" v-model="municipality_code"></CInput>
              <CInput horizontal type="text" label="Τμήμα/Υπηρεσία" id="department" placeholder="π.χ. Τμήμα Προμηθειών" v-model="department"></CInput>
              <CInput horizontal type="text" label="Αριθμός Σύμβασης" id="contract_number" placeholder="Αριθμός δημόσιας σύμβασης" v-model="contract_number"></CInput>
              <CInput horizontal type="text" label="ΑΔΑ Διαύγειας" id="diavgeia_ada" placeholder="π.χ. ΨΧΩΗ46ΨΖ3Ω-ΑΓΛ" v-model="diavgeia_ada"></CInput>
              <CInput horizontal type="text" label="Κωδικός ΕΣΗΔΗΣ" id="esidis_contract_id" placeholder="Κωδικός σύμβασης ΕΣΗΔΗΣ" v-model="esidis_contract_id"></CInput>
              <CInput horizontal type="number" label="Ημέρες Πληρωμής" id="payment_days" placeholder="60" v-model="payment_days"></CInput>
              <CInput horizontal type="email" label="Email Λογιστηρίου" id="accounting_email" placeholder="accounting@example.gov.gr" v-model="accounting_email"></CInput>
              <CInput horizontal type="text" label="Πρωτόκολλο - Γραφείο" id="protocol_office" placeholder="Γραφείο Πρωτοκόλλου" v-model="protocol_office"></CInput>
              <CInput horizontal type="email" label="Email Πρωτοκόλλου" id="protocol_email" placeholder="protocol@example.gov.gr" v-model="protocol_email"></CInput>
            </div>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="12" xl="12">
      <CCard class="servicesCardClient">
        <CCardHeader>
          <strong>Πρότυπα</strong>
        </CCardHeader>
        <CCardBody class="p-0">
          <CForm>
            <div class="servicesCardParts" v-for="(item) in services" :key="item.id">
              <div class="form-group form-row">
                <CCol sm="3">
                  Πρότυπα
                  <multiselect 
                    v-model="item.service" 
                    :options="servicesOptions"
                    @remove="removeSubcontractorPrice(item, $event)"
                    label="label"
                    track-by="label">
                  </multiselect>
                </CCol>
                <CCol sm="3">
                  Σύμβουλος - Πωλητής
                  <multiselect 
                    v-model="item.consultant" 
                    :options="consultantSellers"
                    label="label"
                    @input="calculate_price_for_consultants_and_subcontractors(item, $event)"
                    track-by="label">
                  </multiselect>
                </CCol>
                <CCol sm="3" class="pb-3">
                  Υπεργολάβοι
                  <multiselect 
                    v-model="item.subcontractor" 
                    :options="subcontractors"
                    @input="calculateSubcontractorPrice(item, $event)"
                    @remove="removeSubcontractorPrice(item, $event)"
                    label="label"
                    track-by="label">
                  </multiselect>
                </CCol>
                <CCol sm="2">
                  Ενεργός<br>
                  <CSwitch :checked.sync="item.active" shape="pill" color="success" class="v-middle"/>
                  <span @click="deleteRow(item.id)" class="minusBtn"><CIcon :content="cilMinusBtn" color="danger" :height="20" /></span>
                </CCol>

                <CCol sm="3" class="pt-2">
                  Αμοιβή Προτύπου <span class="labelPrice"><strong>*</strong></span>
                  <CInput type="number" id="price_service" placeholder="Αμοιβή Προτύπου" v-model="item.price_service" @input="calculate_price_for_consultants_and_subcontractors(item, $event)"></CInput>
                </CCol>
                <CCol sm="3" class="pt-2">
                  Αμοιβή Συμβούλου <span class="labelPrice"><strong>*</strong></span>
                  <CInput type="number" id="price_consultant_seller" placeholder="Αμοιβή Συμβούλου - Πωλητή" v-model="item.price_consultant_seller"></CInput>
                </CCol>
                <CCol sm="3" class="pt-2">
                  Αμοιβή Υπεργολάβου <span class="labelPrice"><strong>*</strong></span>
                  <CInput type="number" id="price_subcontractor" placeholder="Αμοιβή Υπεργολάβου" v-model="item.price_subcontractor"></CInput>
                </CCol>
                <CCol sm="3" class="d-flex">
                  <span class="labelPrice align-self-center"><strong>* Τιμή χωρίς ΦΠΑ</strong></span>
                </CCol>

                <CCol sm="12" class="pt-2">
                  <CTextarea
                    label="Πεδίο Πιστοποίησης"
                    rows="2"
                    v-model="item.certification_field"
                  />
                </CCol>
                <CCol sm="12">
                  <CTextarea
                    label="Σημειώσεις"
                    rows="3"
                    v-model="item.notes"
                  />
                </CCol>
              </div>
            </div>
            <CCol sm="12" class="pb-4">
              <CButton color="primary" class="mr-2" @click="addRow()">Προσθήκη</CButton>
              <CButton color="primary" class="mr-2" @click="store()">Αποθήκευση</CButton>
              <CButton color="primary" @click="goBack">Πίσω</CButton>
            </CCol>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import MaskedInput from 'vue-text-mask'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Multiselect from 'vue-multiselect'
import { cilMinus } from '@coreui/icons'
export default {
  name: 'CreateClient',
  components: {
    MaskedInput,
    Multiselect,
  },
  props: {
    caption: {
      type: String,
      default: 'Create Client'
    },
  },
  data: () => {
    return {
        company: '',
        company_en: '',
        email_1: '',
        email_2: '',
        address: '',
        doy: '',
        contact_name: '',
        phone_number_1: '',
        phone_number_2: '',
        deal_sent: true,
        consultantSellers: [],
        afm: '',
        fax: '',
        website: '',
        town: '',
        state: '',
        postcode: '',
        active: true,
        notes: '',
        showMessage: false,
        services: [{id: 0, service: '', consultant: '', active: true, notes: '', subcontractor: '', certification_field: '', price_service: 0, price_consultant_seller: 0, price_subcontractor: 0}],
        servicesOptions: [],
        message: '',
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false,
        masks: {
          input: 'YYYY-MM-DD',
          data: ['YYYY-MM-DD']
        },
        cilMinusBtn: cilMinus,
        subcontractors: [],
        countries: '',
        countriesOptions: [],
        alertIsShown: false,
        signed_deal: false,
        // B2G fields
        is_government: false,
        government_type: null,
        governmentTypeOptions: [
          { value: 'municipality', label: 'Δήμος' },
          { value: 'ministry', label: 'Υπουργείο' },
          { value: 'hospital', label: 'Νοσοκομείο' },
          { value: 'school', label: 'Σχολείο' },
          { value: 'university', label: 'Πανεπιστήμιο' },
          { value: 'region', label: 'Περιφέρεια' },
          { value: 'other', label: 'Άλλος Φορέας' }
        ],
        municipality_code: '',
        department: '',
        contract_number: '',
        diavgeia_ada: '',
        esidis_contract_id: '',
        payment_days: 60,
        accounting_email: '',
        protocol_office: '',
        protocol_email: ''
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/clients'})
    },
    addRow() {
      var id = 1;
      if (this.services.length) {
        id = Math.max.apply(Math,this.services.map(function(o){return o.id;})) + 1;
      }
      this.services.push({id, service: '', consultant: '', active: true, notes: '', subcontractor: '', certification_field: '', price_service: 0, price_consultant_seller: 0, price_subcontractor: 0});
    },
    deleteRow(id) {
      this.services = this.services.filter((item) => item.id != id);
      console.log(this.services);
    },
    store() {
        let self = this;
        let services = self.services.filter((item) => item.service);
        if (services.length) {
          services = self.services.map((item) => {
            return {
              consultant_id: item.consultant ? item.consultant.value : null, 
              service_id: item.service.value, 
              active: item.active, 
              notes: item.notes,
              subcontractor_id: item.subcontractor ? item.subcontractor.value : null,
              certification_field: item.certification_field,
              price_service: item.price_service,
              price_consultant_seller: item.price_consultant_seller,
              price_subcontractor: item.price_subcontractor,
            }
          });
        }

        let countries = null;
        if (this.countries) {
          countries = this.countries.value;
        }

        axios.post('/api/clients?token=' + localStorage.getItem("api_token"),
        {
            email_1: self.email_1,
            email_2: self.email_2,
            company: self.company,
            company_en: self.company_en,
            address: self.address,
            doy: self.doy,
            contact_name: self.contact_name,
            phone_number_1: self.phone_number_1,
            phone_number_2: self.phone_number_2,
            afm: self.afm,
            notes: self.notes,
            countries: countries,
            active: self.active,
            deal_sent: self.deal_sent,
            services: JSON.stringify(services),
            fax: self.fax,
            website: self.website,
            signed_deal: self.signed_deal,
            town: self.town,
            state: self.state,
            postcode: self.postcode,
            // B2G fields
            is_government: self.is_government,
            government_type: self.government_type ? self.government_type.value : null,
            municipality_code: self.municipality_code,
            department: self.department,
            contract_number: self.contract_number,
            diavgeia_ada: self.diavgeia_ada,
            esidis_contract_id: self.esidis_contract_id,
            payment_days: self.payment_days,
            accounting_email: self.accounting_email,
            protocol_office: self.protocol_office,
            protocol_email: self.protocol_email
        })
        .then(function (response) {
            /*self.email_1 = '';
            self.email_2 = '';
            self.company = '';
            self.address = '';
            self.doy = '';
            self.contact_name = '';
            self.phone_number_1 = '';
            self.phone_number_2 = '';
            self.afm = '';
            self.notes = '';
            self.deal_sent = true;*/

            self.message = 'Επιτυχής καταχώρηση πελάτη.';
            self.showAlert();

            axios.post('/api/notifications?token=' + localStorage.getItem("api_token"),
            {
              notification_type: 'clients',
              notification_element_id: response.data.client_id,
              notification_message: 'Καταχωρήθηκε ένας νέος πελάτης'
            })
        }).catch(function (error) {
            console.log('Error:', error);
            if(error.response && error.response.data) {
              // Handle validation errors
              if(error.response.data.errors) {
                self.message = '';
                for (let key in error.response.data.errors) {
                  if (error.response.data.errors.hasOwnProperty(key)) {
                    self.message += error.response.data.errors[key][0] + '  ';
                  }
                }
                self.showAlert();
              }
              // Handle other backend errors
              else if(error.response.data.message) {
                self.message = error.response.data.message;
                self.showAlert();
              }
              // Unauthorized - redirect to login
              else if(error.response.status === 401) {
                self.$router.push({ path: '/login' });
              }
              // Unknown error
              else {
                self.message = 'Παρουσιάστηκε σφάλμα. Παρακαλώ δοκιμάστε ξανά.';
                self.showAlert();
              }
            } else {
              // Network error or no response
              self.message = 'Σφάλμα δικτύου. Ελέγξτε τη σύνδεσή σας.';
              self.showAlert();
            }
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    calculateSubcontractorPrice (item, selectedService) {
      if (selectedService) {
        return item.price_subcontractor = 300;
      }
    },
    removeSubcontractorPrice (item, selectedService) {
        return item.price_subcontractor = 0;
    },
    calculate_price_for_consultants_and_subcontractors (item, price_service) {
      if (item.price_service && item.consultant) {
        let price_service_float = parseFloat(item.price_service);
        
        let final_price_calculated = price_service_float * 0.1

        return item.price_consultant_seller = final_price_calculated.toFixed(2);
      } else {
        return item.price_consultant_seller = 0;
      }
    },

    failAfm(errorMessage){
      this.message = errorMessage
      this.showAlert()
      this.postcode = ''
      this.address  = ''
      this.company  = ''
      this.doy  = ''
      this.town  = ''
    },

    async checkAfm(e){
     if(this.afm.length === 9){
          try {
            const response = await fetch(`/api/check/afm?afm=${this.afm}`, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${localStorage.getItem("api_token")}`
              }
            });
            if(response.status === 200){
              const data = await response.json();
              this.postcode = data.postal_zip_code
              this.address  = `${data.address} ${data.postal_address_no}`
              this.town  = data.region
              this.company  = data.name
              this.doy  = data.doy_desc
            }else{
             this.failAfm('Το ΑΦΜ δεν υπάρχει')
            }
          } catch (error) {
            console.error(error);
          }
     }else{
        this.failAfm('Το ΑΦΜ δεν υπάρχει')
     }
        
    }
  },
  mounted: function(){
    let self = this;
    axios.get('/api/clients/create?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      self.servicesOptions = response.data.services.map((item) => {
        return {
          value: item.id,
          label: item.name
        }
      });
      self.consultantSellers = response.data.consultants.map((item) => {
        return {
          value: item.id,
          label: item.name
        }
      });
      self.subcontractors = response.data.subcontractors.map((item) => {
        return {
          value: item.id,
          label: item.name
        }
      });
      self.countriesOptions = response.data.countries.map((item) => {
        return {
          value: item.id,
          label: item.name
        }
      });
      self.countries = self.countriesOptions[66];
      //self.services = [self.servicesOptions[0]];
    }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
    });
  }
}


</script>
